// Support ticket #1026 (ASP, 2026-10-30): a 70-character Target overflowed the NVARCHAR(64) column in
// carerx_care_plan_goals (migration 313) and the whole care plan failed with a generic 500. Migration 456
// widened the free-text goal columns to 300. These mirror
// the server's CareRxCarePlanGoalLimits so the page can cap the inputs and name the field before posting.
// Keep in lock-step with the schema: widening a column means raising the number here and on the server.
export const GOAL_FIELD_LIMITS = {
  measure: 300,
  unit: 24,
  baseline_value: 300,
  target_value: 300,
} as const

export type LimitedGoalField = keyof typeof GOAL_FIELD_LIMITS

const LABELS: Record<LimitedGoalField, string> = {
  measure: 'Measure', unit: 'Unit', baseline_value: 'Baseline', target_value: 'Target',
}

export type GoalFieldViolation = { goalIndex: number; field: LimitedGoalField; length: number; limit: number; message: string }

/** First over-long field across the goals, in goal order then field order, or null when everything fits. */
export function goalFieldViolation(goals: ReadonlyArray<Partial<Record<LimitedGoalField, string | null | undefined>>>): GoalFieldViolation | null {
  for (let i = 0; i < goals.length; i++) {
    for (const field of Object.keys(GOAL_FIELD_LIMITS) as LimitedGoalField[]) {
      const value = goals[i][field] ?? ''
      const limit = GOAL_FIELD_LIMITS[field]
      if (value.length > limit) {
        return { goalIndex: i, field, length: value.length, limit, message: `Goal ${i + 1}: ${LABELS[field]} is ${value.length} characters; the limit is ${limit}.` }
      }
    }
  }
  return null
}
